import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class TeaserGroupSlider {
	constructor() {
		this.breakpoint = window.matchMedia('(max-width: 767px)');
		this.groups = new Map();
		this.handleBreakpointChange = this.update.bind(this);
	}

	init() {
		this.update();
		this.breakpoint.addEventListener('change', this.handleBreakpointChange);
	}

	update() {
		for (const group of document.querySelectorAll('.teaser-group')) {
			if (this.breakpoint.matches) {
				this.initSlider(group);
			} else {
				this.destroySlider(group);
			}
		}
	}

	initSlider(group) {
		if (this.groups.has(group)) {
			return;
		}

		const container = group.querySelector('.teaser-group-elements');
		const slides = container ? Array.from(container.children) : [];

		if (!container || slides.length < 2) {
			return;
		}

		const wrapper = document.createElement('div');
		const controls = document.createElement('div');
		const previousButton = document.createElement('button');
		const pagination = document.createElement('div');
		const nextButton = document.createElement('button');

		wrapper.className = 'swiper-wrapper';
		controls.className = 'teaser-group-controls';
		previousButton.className =
			'teaser-group-navigation teaser-group-navigation--previous';
		previousButton.type = 'button';
		previousButton.setAttribute('aria-label', 'Vorherige Karte');
		previousButton.innerHTML =
			'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';
		pagination.className = 'teaser-group-pagination swiper-pagination';
		nextButton.className =
			'teaser-group-navigation teaser-group-navigation--next';
		nextButton.type = 'button';
		nextButton.setAttribute('aria-label', 'Nächste Karte');
		nextButton.innerHTML =
			'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';

		for (const slide of slides) {
			slide.classList.add('swiper-slide');
			wrapper.appendChild(slide);
		}

		controls.append(previousButton, pagination, nextButton);
		container.replaceChildren(wrapper, controls);
		container.classList.add('swiper');

		const swiper = new Swiper(container, {
			slidesPerView: 1,
			spaceBetween: 16,
			grabCursor: true,
			watchOverflow: true,
			pagination: {
				el: pagination,
				clickable: true,
			},
		});

		const updateNavigation = () => {
			previousButton.disabled = swiper.isBeginning;
			nextButton.disabled = swiper.isEnd;
		};

		previousButton.addEventListener('click', () => swiper.slidePrev());
		nextButton.addEventListener('click', () => swiper.slideNext());
		swiper.on('slideChange', updateNavigation);
		swiper.on('resize', updateNavigation);
		updateNavigation();

		this.groups.set(group, {
			container,
			slides,
			swiper,
		});
	}

	destroySlider(group) {
		const state = this.groups.get(group);

		if (!state) {
			return;
		}

		state.swiper.destroy(true, true);
		for (const slide of state.slides) {
			slide.classList.remove('swiper-slide');
			slide.removeAttribute('style');
		}

		state.container.classList.remove('swiper');
		state.container.replaceChildren(...state.slides);
		this.groups.delete(group);
	}
}
